import { render, staticRenderFns } from "./selectgys.vue?vue&type=template&id=4399afb8"
import script from "./selectgys.vue?vue&type=script&lang=js"
export * from "./selectgys.vue?vue&type=script&lang=js"
import style0 from "./selectgys.vue?vue&type=style&index=0&id=4399afb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports